<!--  -->
<template>
  <div>
    <div v-if="allid!=''" class="container" :style="{ width: imgobj.width + 'px', height: imgobj.height + 'px' }" @mousedown="onMouseDown" @mousemove="onMouseMove" @mouseup="onMouseUp">
      <div ref="backgroundImage" class="image-container" :style="{ backgroundImage: 'url(' + allimg + ')' }">
        <div
          v-for="item in list"
          :key="item.id"
          class="drag-item"
          :style="{ top: item.y + 'px', left: item.x + 'px' }"
          @mousedown="onItemMouseDown(item, $event)"
        >
          <img :src="item.img" alt="image" :style="{ width: item.icon_width + 'px', height: item.icon_height + 'px',transform: 'rotate(' + item.icon_rotate + 'deg)' }">
        </div>
      </div>
    </div>
    <div v-if="allid==''">
      <div style="margin: 20px;">背景图</div>
      <div class="updata_box" @click="materiallibrary(1)">
        <i class="el-icon-plus" />
      </div>
    </div>
    <div style="margin: 50px 0px 30px 50px;">
      <el-button type="primary" size="mini" @click="materiallibrary(1)">更换背景图</el-button>
      <el-button type="primary" size="mini" @click="materiallibrary(2)">添加图片</el-button>
    </div>
    <div class="explain_box">
      <div class="sderwtw">分类类型：</div>
      <el-autocomplete
        v-model="assort_name"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入内容"
        :disabled="savetype == 2"
        @select="handleSelect"
      />
    </div>
    <div class="explain_box">
      <div class="sderwtw">玩法说明：</div>
      <el-input
        v-model="play_explain"
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 4}"
        placeholder="请输入玩法说明"
        style="width: 500px;"
      />
    </div>
    <div class="explain_box">
      <div class="sderwtw">可玩次数：</div>
      <el-input
        v-model="level_count"
        placeholder="请输入可玩次数"
        style="width: 500px;"
      />
    </div>
    <div v-if="dsawer">
      <div v-for="itemr,twoIndex in list" :key="'info-'+ twoIndex" style="margin: 30px;" class="daewrw">
        <span class="sderwtw">x：</span> <el-input-number v-model="itemr.x" label="x" style="margin-right: 10px;" />
        <span class="sderwtw">y：</span><el-input-number v-model="itemr.y" label="y" style="margin-right: 10px;" />
        <span class="sderwtw"> x间距：</span><el-input-number v-model="itemr.x_range" label="x间距" style="margin-right: 10px;" />
        <span class="sderwtw"> y间距：</span><el-input-number v-model="itemr.y_range" label="y间距" style="margin-right: 10px;" />
        <span class="sderwtw"> 备注：</span><el-input v-model="itemr.remark" style="width: 200px;margin-right: 10px;" label="备注" />
        <span class="sderwtw"> 宽：</span><el-input-number v-model="itemr.icon_width" label="宽" style="margin-right: 10px;" />
        <span class="sderwtw"> 高：</span><el-input-number v-model="itemr.icon_height" label="高" style="margin-right: 10px;" />
        <span class="sderwtw"> 角度：</span><el-input-number v-model="itemr.icon_rotate" label="旋转角度" style="margin-right: 10px;" />
        <img :src="itemr.img" alt="" style="width: 50px;height: 50px;margin-left: 10px;">
        <el-button style="margin-left: 10px;" type="success" size="mini" @click="edit(3,twoIndex)">编辑</el-button>
        <el-button v-if="list.length!=1" style="margin-left: 10px;" type="danger" size="mini" @click="deltrert(twoIndex)">删除</el-button>
      </div>
    </div>
    <div v-if="list.length!=0" style="margin: 0px 0px 0px 40px">
      <el-button style="margin-left: 10px;" type="success" size="mini" @click="save">保存</el-button>
      <!-- <el-button style="margin-left: 10px;" type="success" size="mini" @click="saver">下载</el-button> -->
    </div>

    <canvas ref="canvas" />

    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisibletwo"
      width="50%"
      append-to-body
    >
      <chooseimg ref="mychild" @clickicon="clickicon" />
    </el-dialog>
  </div>
</template>

<script>
import chooseimg from './components/chooseimg.vue'
import { qiniuToken } from '@/api/qiniuToken.js'
import * as qiniu from 'qiniu-js'
import getNowDate from '@/utils/mixins/convertToHump.js'
import { storeSet, iconsSetdetails, iconsSetupdate, assortlist } from '@/api/sourceMaterial.js'
export default {
  components: { chooseimg },
  mixins: [getNowDate],
  data() {
    return {
      allimg: '',
      allid: '',
      list: [
        // {
        //   img: 'https://ziyuan.jingxuansz.com/user/7roc1n-231110113710451914.jpg',
        //   x: 20,
        //   y: 10,
        //   keyid: 1
        // },
        // {
        //   img: 'https://ziyuan.jingxuansz.com/user/7roc1n-231110113710451914.jpg',
        //   x: 50,
        //   y: 60,
        //   keyid: 2
        // },
        // {
        //   img: 'https://ziyuan.jingxuansz.com/user/7roc1n-231110113710451914.jpg',
        //   x: 90,
        //   y: 100,
        //   keyid: 3
        // }
      ],
      dialogVisibletwo: false,
      dsawer: true,
      type: null,
      twoIndex: null,
      activeItem: null,
      offset: { x: 0, y: 0 },
      imgobj: {},
      savetype: null,
      imageData: '',
      token: null,
      chuanicons_list: [],
      percentkey: '',
      final_id: null,
      loading: null,
      play_explain: '',
      assort_id: null,
      level_count: '',
      assort_name: ''
    }
  },
  created() {
    this.savetype = this.$route.query.type
    console.log(this.$route.query.final_id)
    this.final_id = this.$route.query.final_id
    this.getQiniuToken()
    // eslint-disable-next-line eqeqeq
    if (this.$route.query.final_id != undefined) {
      this.getdetail()
    }
  },
  mounted() {

  },
  methods: {
    // 获取token
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },
    async sawrlist() {
      const data = await assortlist(this.paquery)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data.data)
    },
    // 搜索手机编号
    async querySearchAsync(value, cb) {
      const data = await assortlist({ name: value, page: 1, page_size: 100 })
      cb(data.data.list.map((item) => { return { ...item, value: item.name, address: item.id } }))
    },

    // 获取详情
    async getdetail() {
      const data = await iconsSetdetails({
        final_id: this.final_id
      })
      this.percentkey = data.data.final_info.key
      this.allimg = data.data.underlay_info.path
      this.allid = data.data.underlay_info.id
      this.imgobj.width = data.data.underlay_info.weight// 底图宽
      this.imgobj.height = data.data.underlay_info.height// 底图高
      this.assort_name = data.data.final_info.assort_name
      this.assort_id = data.data.final_info.assort_id
      this.play_explain = data.data.final_info.play_explain
      this.level_count = data.data.final_info.level_count
      this.list = data.data.icons_info.map(item => { // item是数组中的每一个值
        return {
          x: item.x_axis,
          y: item.y_axis,
          keyid: item.uid,
          x_range: item.x_range,
          y_range: item.y_range,
          remark: item.remark,
          img: item.path,
          icon_width: item.icon_width,
          icon_height: item.icon_height,
          icon_rotate: item.icon_rotate
        }
      })
      console.log('data', data.data)
    },
    oncanvas() {
      const that = this
      // eslint-disable-next-line eqeqeq
      if (that.play_explain == '') {
        that.$message.error('请填写玩法说明')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (that.level_count == '') {
        that.$message.error('请填写可玩次数')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (that.assort_id == null) {
        that.$message.error('请选择分类类型')
        return
      }
      this.loading = that.$loading({
        lock: true,
        text: '正在保存...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var canvas = this.$refs.canvas
      const ctx = canvas.getContext('2d')
      canvas.width = this.imgobj.width// 底图宽
      canvas.height = this.imgobj.height// 底图高
      // 加载图像
      const imgr = new Image()
      imgr.crossOrigin = 'anonymous' // 设置跨域属性
      imgr.src = this.allimg

      // 等待所有图像加载完成
      Promise.all([this.imageLoaded(imgr)])
        .then(() => {
          // 绘制图像到Canvas中
          ctx.drawImage(imgr, 0, 0, this.imgobj.width, this.imgobj.height)
        })

      setTimeout(() => {
        that.list.forEach((item, index) => {
          var dynamicVariableName = 'img' + index
          dynamicVariableName = new Image()
          dynamicVariableName.crossOrigin = 'anonymous' // 设置跨域属性
          dynamicVariableName.src = item.img
          Promise.all([this.imageLoaded(dynamicVariableName)])
            .then(() => {
              const angleInRadians = item.icon_rotate * Math.PI / 180 // 旋转角度（45度）
              const centerX = item.x + item.icon_width / 2 // 图片中心点 x 坐标
              const centerY = item.y + item.icon_height / 2 // 图片中心点 y 坐标
              ctx.translate(centerX, centerY) // 将坐标原点移动到图片中心点
              ctx.rotate(angleInRadians) // 旋转画布
              ctx.drawImage(dynamicVariableName, -item.icon_width / 2, -item.icon_height / 2, item.icon_width, item.icon_height) // 绘制图像，以图片左侧为基准
              // 恢复画布状态（可选）
              ctx.rotate(-angleInRadians)
              ctx.translate(-centerX, -centerY)
              // console.log('item.img', item.x, item.y, dynamicVariableName)
              // ctx.drawImage(dynamicVariableName, item.x, item.y, item.icon_width, item.icon_height)
            })
        })
        // 使用requestAnimationFrame检测Canvas是否已经完成渲染
        requestAnimationFrame(() => {
          setTimeout(() => {
            const dataURL = canvas.toDataURL('image/png')
            that.imageData = dataURL
            const blob = that.dataURLToBlob(dataURL)
            that.uploadToQiniu(blob)
          }, 2000)
        })
      }, 1000)
    },
    uploadToQiniu(blob) {
      console.log(blob)
      const that = this
      const ftype = '.png' // 替换为您的七牛云上传凭证
      const key = `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}` // 替换为您要保存到七牛云的文件名
      const config = {
        useCdnDomain: true
      }
      const observable = qiniu.upload(blob, key, this.token, {}, config)
      observable.subscribe({
        next(response) {
          // 可选：上传进度回调
          console.log('Upload progress:', response.total.percent.key)
        },
        error(err) {
          // 上传错误处理
          console.error('Upload error:', err)
        },
        complete(response) {
          // 上传完成处理
          console.log('Upload complete:', response)
          console.log(that.percentkey)
          that.percentkey = ''
          that.percentkey = response.key
          that.chuanicons_list = []
          that.chuanicons_list = that.list.map(item => { // item是数组中的每一个值
            return {
              x_axis: item.x,
              y_axis: item.y,
              uid: item.keyid,
              x_range: item.x_range,
              y_range: item.y_range,
              remark: item.remark,
              icon_width: item.icon_width,
              icon_height: item.icon_height,
              icon_rotate: item.icon_rotate
            }
          })
          // eslint-disable-next-line eqeqeq
          if (that.savetype == 1) {
            storeSet({
              pid: that.allid,
              icons_list: that.chuanicons_list,
              final_photo: { key: that.percentkey, play_explain: that.play_explain, level_count: that.level_count, assort_id: that.assort_id }
            }).then((res) => {
              console.log('res', res)
              that.loading.close()
              that.$router.push({ path: '/seelookList/index' })
            })
          } else {
            console.log('编辑')
            iconsSetupdate({
              final_id: that.final_id,
              pid: that.allid,
              icons_list: that.chuanicons_list,
              final_photo: { key: that.percentkey, play_explain: that.play_explain, level_count: that.level_count, assort_id: that.assort_id }
            }).then((res) => {
              console.log('res', res)
              that.loading.close()
              that.$router.push({ path: '/seelookList/index' })
            })
          }
        }
      })
    },
    dataURLToBlob(dataURL) {
      const arr = dataURL.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    imageLoaded(image) {
      return new Promise((resolve, reject) => {
        image.onload = resolve
        image.onerror = reject
      })
    },
    edit(type, twoIndex) {
      this.type = type
      this.twoIndex = twoIndex
      this.dialogVisibletwo = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick(2)
      }, 100)
    },
    materiallibrary(type) {
      // eslint-disable-next-line eqeqeq
      if (this.allid == '' && type == 2) {
        this.$message.error('请选择背景图')
        return
      }
      this.type = type
      this.dialogVisibletwo = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick(type)
      }, 100)
    },
    clickicon(img, key, item) {
      this.dialogVisibletwo = false
      if (this.type === 2) {
        this.dsawer = false
        this.list.push({
          x: 100,
          y: 100,
          keyid: key,
          img: img,
          x_range: '',
          y_range: '',
          remark: '',
          icon_width: item.weight,
          icon_height: item.height,
          icon_rotate: 0
        })
        this.dsawer = true
      } else if (this.type === 1) {
        console.log(img, key, item)
        const that = this
        that.imgobj.width = item.weight
        that.imgobj.height = item.height
        that.allimg = img
        that.allid = key
        // this.allid = key
        // var imgr = new Image()
        // // 图片地址
        // imgr.src = img
        // let res = {}
        // imgr.onload = function() {
        //   res = {
        //     width: imgr.width,
        //     height: imgr.height
        //   }
        //   that.imgobj = res
        //   console.log(res) // 获取到图片的宽高
        //   that.allimg = img
        // }
      } else {
        this.dsawer = false
        this.list[this.twoIndex].img = img
        this.list[this.twoIndex].keyid = key
        this.dsawer = true
      }
    },
    deltrert(index) {
      this.list.splice(index, 1)
    },
    onMouseDown(event) {
    // 处理鼠标按下事件
    // 可以在这里记录鼠标按下的位置等信息
    // 您可以根据需要进行进一步的处理
    },
    onMouseMove(event) {
    // 处理鼠标移动事件
    // 可以在这里根据鼠标移动的位置计算偏移量，并更新图片元素的位置信息
      if (this.activeItem) {
        this.activeItem.x = event.pageX - this.offset.x
        this.activeItem.y = event.pageY - this.offset.y
      }
    },
    onMouseUp(event) {
    // 处理鼠标松开事件
    // 可以在这里清除活动元素等信息
      this.activeItem = null
      this.offset = { x: 0, y: 0 }
    },
    onItemMouseDown(item, event) {
    // 处理图片元素的鼠标按下事件
    // 可以在这里记录活动元素和鼠标偏移量等信息
      this.activeItem = item
      this.offset.x = event.pageX - item.x
      this.offset.y = event.pageY - item.y
    },
    save() {
      console.log('保存')
      this.oncanvas()
      // this.$router.push({ path: '/seelookList/index' })
    },

    handleSelect(item) {
      console.log(item)
      this.assort_id = item.id
      this.assort_name = item.name
    },
    saver() {
      // const canvas = this.$refs.canvas
      // var ctxr = canvas.getContext('2d')
      // canvas.width = this.imgobj.width
      // canvas.height = this.imgobj.height
      // var imgwe = new Image()
      // imgwe.setAttribute('crossOrigin', 'anonymous')
      // imgwe.onload = function() {
      //   ctxr.drawImage(imgwe, 0, 0)
      // }
      // imgwe.src = 'image.jpg'
      // var dataURL = canvas.toDataURL()
      // var link = document.createElement('a')
      // link.href = dataURL
      // link.download = 'image.png'
      // document.body.appendChild(link)
      // link.click()
      // document.body.removeChild(link)
      // const canvas = this.$refs.canvas
      // const dataURL = canvas.toDataURL('image/png')
      // const link = document.createElement('a')
      // link.download = 'myImage.png'
      // link.href = dataURL
      // document.body.appendChild(link)
      // link.click()
      console.log('imageData', this.imageData)
      const link = document.createElement('a')
      link.download = 'myImage.png'
      link.href = this.imageData
      document.body.appendChild(link)
      link.click()
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.daewrw{
  display: flex;
  align-items: center;
}
.updata_box{
  width: 200px;
  height: 200px;
border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    text-align: center;
    line-height: 200px;
    margin-left: 20px;
    margin-top: 50px;
}

.container {
  position: relative;
}
.image-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
}
.drag-item {
  position: absolute;
  cursor: move;
}
.explain_box{
  display: flex;
  align-items: center;
  margin-left: 30px;
  margin-top: 10px;
}
.sderwtw{
  color: rgb(169, 162, 151);
  font-size: 14px;
}
</style>
